import { h } from '@stencil/core/internal/client';

function wrapInTooltip(tooltipProp, content) {
    if (tooltipProp) {
        const tooltipProps = typeof tooltipProp === 'object' ? tooltipProp : { label: tooltipProp };
        return h("wui-tooltip", { ...tooltipProps }, content);
    }
    return content;
}

export { wrapInTooltip as w };

//# sourceMappingURL=util2.js.map